<template>
  <b-container>
    <h1>Statistiques</h1>

    <b-form class="filter">
      <div class="group">
        <img src="/static/img/filter.svg" alt="Filter" id="picto-filter">
      </div>

      <div class="group">
        <label class="mr-sm-2" for="agency">Agence</label>
        <b-form-select id="agency" v-model="filterType">
          <template slot="first">
            <option :value="null">Toutes les agences</option>
          </template>
          <option value="ATIS">ATIS</option>
          <option value="ARIT">ARIT</option>
        </b-form-select>
      </div>

      <div class="group">
        <label class="mr-sm-2" for="site">Site</label>
        <b-form-select id="site" v-model="filterAgencies" :options="formattedAgencies">
          <template slot="first">
            <option :value="null">Tous les sites</option>
          </template>
        </b-form-select>
      </div>

      <div class="group">
        <label class="mr-sm-2" for="from">Du</label>
        <div style="position: relative"><date-picker id="from" v-model="slice.from"
              :config="config"
              placeholder="JJ/MM/AAAA"
              class="tranche-date-picker"
              :class="(invalidDateFrom ? 'is-invalid' : '')">
        </date-picker></div>
      </div>

      <div class="group">
        <label class="mr-sm-2" for="to">Au</label>
        <div style="position: relative"><date-picker id="to" v-model="slice.to"
              :config="config"
              placeholder="JJ/MM/AAAA"
              class="tranche-date-picker"
              :class="(invalidDateTo ? 'is-invalid' : '')">
        </date-picker></div>
      </div>

      <div class="group">
        <b-button variant="primary" @click="sendRequest" size="sm" :disabled="!btnReady" id="sendFilter">Valider</b-button>
      </div>

      <div class="group">
        <b-button variant="outline-primary" @click="resetFilters" size="sm" id="filterResetBtn"><span id="picto-reset"></span>Réinitialiser les filtres</b-button>
      </div>
    </b-form>

    <div v-show="ready == true">

      <h3 v-if="slicesInTimeframe <= 1">{{ slicesInTimeframe }} dossier complet et en cours trouvé.</h3>
      <h3 v-if="slicesInTimeframe > 1">{{ slicesInTimeframe }} dossiers complets et en cours trouvés.</h3>

      <h4 v-if="openSlices <= 1">{{ openSlices }} <span class="tooltip-message" v-b-tooltip.hover :title="tooltipMessage">dossier en cours</span>.</h4>
      <h4 v-if="openSlices > 1">{{ openSlices }} <span class="tooltip-message" v-b-tooltip.hover :title="tooltipMessage">dossiers en cours</span>.</h4>

      <div role="tablist" v-show="slicesInTimeframe > 0" class="stats-main-container">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-0" role="tab">
            <b-button block class="stat-toggle-btn" href="#" v-b-toggle.accordion-1 variant="info">Dossiers</b-button>
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-row>
                <b-col cols="6" offset="3">
                  <b-form-group label="Chargé d'affaire :" label-cols="3">
                    <b-form-select id="caseManager" v-model="filterCaseManagers" :options="formattedCaseManagers" @change="sendRequest">
                      <template slot="first">
                        <option :value="null">Tous les chargés d'affaire</option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="centered-block">
                  <h2>Délais de réception des dossiers</h2>
                  <h3>(Période sélectionnée)</h3>
                  <apexchart width="400" type="pie" :options="apexCharts.slicesUnderDelay.options" :series="apexCharts.slicesUnderDelay.series"/>
                </b-col>
                <b-col class="centered-block">
                  <h2>Conformité des dossiers</h2>
                  <h3>(Période sélectionnée)</h3>
                  <apexchart width="400" type="pie" :options="apexCharts.slicesWithNoGaps.options" :series="apexCharts.slicesWithNoGaps.series"/>
                </b-col>
              </b-row>

              <b-row class="stats-container">
                <div class="stat">
                  <h2>Délais de réception des dossiers</h2>
                  <h3>(12 derniers mois)</h3>
                  <span v-if="displaySlicesUnderDelayForManager">
                    <apexchart width="400" type="pie" :options="apexCharts.slicesUnderDelayForManager.options" :series="apexCharts.slicesUnderDelayForManager.series"/>
                  </span>
                  <span class="mt-4" v-else>
                    Pas de données à afficher
                  </span>
                </div>
                <div class="stat">
                  <h2>Conformité des dossiers</h2>
                  <h3>(12 derniers mois)</h3>
                  <span v-if="displayConformityCasesForManager">
                    <apexchart width="400" type="pie" :options="apexCharts.conformityCasesForManager.options" :series="apexCharts.conformityCasesForManager.series"/>
                  </span>
                  <span class="mt-4" v-else>
                    Pas de données à afficher
                  </span>
                </div>
              </b-row>

              <b-row>
                <b-col class="text-center">
                  <h2 class="mt-4">Délais de réception</h2>
                  <h3 class="mb-4">(12 derniers mois)</h3>
                  <span v-if="displayDelayProgression">
                    <apexchart type="bar" :options="apexCharts.inDelayProgression.options" :series="delayProgressionPercent"/>
                  </span>
                  <span class="mt-4" v-else>
                    Pas de données à afficher
                  </span>
                </b-col>
                <b-col class="text-center">
                  <h2 class="mt-4">Conformité des dossiers</h2>
                  <h3 class="mb-4">(12 derniers mois)</h3>
                  <span v-if="displayConformityProgression">
                    <apexchart type="bar" :options="apexCharts.conformityProgression.options" :series="conformityProgressionPercent"/>
                  </span>
                  <span class="mt-4" v-else>
                    Pas de données à afficher
                  </span>
                </b-col>
              </b-row>
            </b-card-body>
          </b-collapse>

          <b-card-header header-tag="header" class="p-0" role="tab">
            <b-button block class="stat-toggle-btn" href="#" v-b-toggle.accordion-2 variant="info">Aléas</b-button>
          </b-card-header>
          <b-collapse id="accordion-2" visible accordion="my-second-accordion" role="tabpanel">
            <b-card-body class="stats-container">
              <div class="stat">
                <h3>Nombre d'aléas : {{ nbGaps }}</h3>
              </div>
            </b-card-body>
          </b-collapse>

          <b-card-header header-tag="header" class="p-0" role="tab">
            <b-button block class="stat-toggle-btn" href="#" v-b-toggle.accordion-3 variant="info">Typologie d'aléas</b-button>
          </b-card-header>
          <b-collapse id="accordion-3" visible accordion="my-third-accordion" role="tabpanel">
            <b-card-body>
              <b-row>
                <b-col class="text-center">
                  <h2 class="mt-4 mb-4">10 aléas les plus frequemments relevés</h2>
                  <apexchart type="bar" :options="apexCharts.tenMostCommonGaps.options" :series="apexCharts.tenMostCommonGaps.series" class="centered-chart"/>
                </b-col>
                <b-col class="text-center">
                  <h2 class="mt-4 mb-4">Description des aléas</h2>
                  <b-table small :items="tenMostCommonGaps" :fields="fields" class="small-table"></b-table>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="text-center">
                  <h2 class="mt-5 mb-4"><span class="tooltip-message" v-b-tooltip.hover title="Précision : cette statistique ne prend en compte que les aléas de type 'A'.">Types d'aléas</span></h2>
                  <apexchart class="centered-chart" width="400" type="pie" :options="apexCharts.gapTypes.options" :series="apexCharts.gapTypes.series"/>
                </b-col>
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>

  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Clone from 'clone';
import TrancheService from '../../../services/TrancheService';

const moment = require('moment');

export default {
  name: 'Statistics',
  data() {
    return {
      enedisCases: null,
      slice: {
        from: null,
        to: null,
      },
      filterAgencies: null,
      filterType: null,
      filterCaseManagers: null,
      agencies: [],
      formattedAgencies: [],
      caseManagers: [],
      formattedCaseManagers: [],
      slicesStats: [],
      inDelayForManager: 0,
      outDelayForManager: 0,
      conformCasesForManager: 0,
      nonConformCasesForManager: 0,
      slicesInTimeframe: null,
      slices: null,
      openSlices: null,
      slicesReceivedInTime: null,
      slicesNotReceivedInTime: null,
      slicesWithNoGaps: null,
      slicesWithGaps: null,
      ready: false,
      btnReady: true,
      invalidDateFrom: false,
      invalidDateTo: false,
      nbGaps: null,
      allGaps: [],
      gapsTable: [],
      gapTypesA: [],
      stackedBar: {
        labels: [],
        datasets: [{
          label: 'A',
          backgroundColor: 'lightblue',
          data: [],
        },
        {
          label: 'B',
          backgroundColor: 'lightcoral',
          data: [],
        }],
      },
      gapTypeIncomplete: 0,
      gapTypeInadmissible: 0,
      gapTypeReactive: 0,
      tooltipMessage: "Les statistiques portent sur les dossiers la date de réception est comprise dans l'intervalle de date choisie.",
      charts: {
        gapTypes: null,
        tenMostCommonGaps: null,
        slicesWithNoGaps: null,
        slicesUnderDelay: null,
      },
      apexCharts: {},
      tenMostCommonGaps: [],
      conformityProgression: [],
      conformityProgressionPercent: [],
      delayProgression: [],
      delayProgressionPercent: [],
      fields: [
        {
          key: 'code',
          label: 'Code',
          sortable: true,
        },
        {
          key: 'description',
          label: 'Description',
          sortable: true,
        },
      ],
      displayConformityCasesForManager: false,
      displaySlicesUnderDelayForManager: false,
      displayDelayProgression: false,
      displayConformityProgression: false,
    }
  },
  methods: {
    ...mapActions([
      'fetchAgencies',
      'fetchCaseManagers',
    ]),
    ...mapGetters([
      'getUserSession',
      'getTrancheStatusEnumeration',
      'getViewPortSize',
      'getAgencies',
      'getCaseManagers',
    ]),
    resetFilters() {
      this.filterAgencies = null;
      this.filterType = null;
      this.filterCaseManagers = null;

      let currentYear = moment(new Date(), 'YYYY-MM-DD HH:mm').format('YYYY');

      this.slice.from = moment(currentYear + '-01-01 00:01', 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
      this.slice.to = moment(currentYear + '-12-31 23:59', 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
    },
    sendRequest() {
      // Reset graphs
      this.resetApexChartsData();

      // Error classes
      (this.slice.from == null) ? this.invalidDateFrom = true : this.invalidDateFrom = false;
      (this.slice.to == null) ? this.invalidDateTo = true : this.invalidDateTo = false;

      if (this.slice.from == null || this.slice.to == null) {
        // Show error toast
        const toast = {
          show: true,
          message: 'Merci de préciser les dates pour pouvoir afficher vos statistiques.',
          variant: 'danger',
          duration: 3000,
        };
        this.$store.commit('setGlobalToaster', toast);
        return;
      } else {
        this.ready = false;
        this.btnReady = false;
        axios.get('/tranches', {
          params: {
            'type': this.filterType,
            'agency': this.filterAgencies,
            'caseManager': this.filterCaseManagers,
            'from': this.formatDate(this.slice.from),
            'to': this.formatDate(this.slice.to),
          }
        })
        .then((response) => {
          this.slices = response.data;
        })
        .finally(() => {
          this.ready = true;
          this.btnReady = true;
        });
      }
    },
    formatDate(date) {
      return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    },
    displayRate(total, items) {
      return Math.ceil(items / total * 100);
    },
    resetApexChartsData() {
      this.apexCharts = {
        slicesUnderDelay: {
          options: {
            labels: [
              'Reçus dans les délais',
              'Reçus hors délais',
            ],
            colors: ['#58C79C', '#EF5350'],
            dataLabels: {
              formatter: function(val, opts) {
                return `${opts.w.globals.labels[opts.seriesIndex]} : ${opts.w.globals.series[opts.seriesIndex]} (${opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(2)}%)`;
              },
            },
          },
          data: [],
        },
        slicesUnderDelayForManager: {
          options: {
            labels: [
              'Reçus dans les délais',
              'Reçus hors délais',
            ],
            colors: ['#58C79C', '#EF5350'],
            dataLabels: {
              formatter: function(val, opts) {
                return `${opts.w.globals.labels[opts.seriesIndex]} : ${opts.w.globals.series[opts.seriesIndex]} (${opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(2)}%)`;
              },
            },
          },
          data: [],
        },
        slicesWithNoGaps: {
          options: {
            labels: [
              'Dossiers conformes',
              'Dossiers non conformes',
            ],
            colors: ['#58C79C', '#EF5350'],
            dataLabels: {
              formatter: function(val, opts) {
                return `${opts.w.globals.labels[opts.seriesIndex]} : ${opts.w.globals.series[opts.seriesIndex]} (${opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(2)}%)`;
              },
            },
          },
          data: [],
        },
        gapTypes: {
          options: {},
          data: [],
        },
        gapTypes: {
          options: {},
          data: [],
        },
        conformityCasesForManager: {
          options: {
            labels: [
              'Dossiers conformes',
              'Dossiers non conformes',
            ],
            colors: ['#58C79C', '#EF5350'],
            dataLabels: {
              formatter: function(val, opts) {
                return `${opts.w.globals.labels[opts.seriesIndex]} : ${opts.w.globals.series[opts.seriesIndex]} (${opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(2)}%)`;
              },
            },
          },
          data: [],
        },
        gapTypes: {
          options: {},
          data: [],
        },
        tenMostCommonGaps: {
          options: {
            chart: {
              stacked: true,
              toolbar: {
                show: false,
              },
            },
            tooltip: {
              y: {
                formatter: function(val, opts) {
                  return val;
                }
              }
            },
            xaxis: {
              categories: []
            }
          },
          series: [],
        },
        conformityProgression: {
          options: {
            chart: {
              stacked: true,
              toolbar: {
                show: false,
              },
            },
            colors: ['#58C79C', '#EF5350'],
            dataLabels: {
              formatter: function(val, opts) {
                return `${val} %`;
              },
            },
            tooltip: {
              y: {
                formatter: function(val, opts) {
                  return `${val} %`;
                }
              }
            },
            xaxis: {},
            yaxis: {
              show: false,
            }
          },
          series: [],
        },
        inDelayProgression: {
          options: {
            chart: {
              stacked: true,
              toolbar: {
                show: false,
              },
            },
            colors: ['#58C79C', '#EF5350'],
            dataLabels: {
              formatter: function(val, opts) {
                return `${val} %`;
              },
            },
            tooltip: {
              y: {
                formatter: function(val, opts) {
                  return `${val} %`;
                }
              }
            },
            xaxis: {},
            yaxis: {
              show: false,
            }
          },
          series: [],
        }
      }
    },
    getMonthsProgression() {
      let d = new Date();
      let month = ["Janv.", "Févr.", "Mars", "Avr.", "Mai", "Juin", "Juill.", "Août", "Sept.", "Oct.", "Nov.", "Déc."];
      let months = [];
      for (let i = 0; i < 12; i++) {
        let index = d.getMonth() - i;
        let e = new Date();
        let mi = index;
        e.setMonth(e.getMonth() - i);
        if (index < 0) {
          mi = 12 + index;
        }
        months.push(month[mi] + ' ' + e.getFullYear());
      }
      return months.reverse();
    }
  },
  computed: {
    config() {
      const size = this.getViewPortSize();
      return {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        locale: moment.locale('fr'),
        focusOnShow: false,
        ignoreReadonly: true,
        allowInputToggle: true,
        widgetPositioning: {
          horizontal: ['sm', 'xs'].indexOf(size) !== -1 ? 'right' : 'left',
        },
      };
    }
  },
  watch: {
    agencies(newVal) {
      this.formattedAgencies = [];
      let agenciesName = [];

      newVal.forEach((item, index) => {
        if (agenciesName.indexOf(item.name) === -1) {
          agenciesName.push(item.name);
          this.formattedAgencies.push({ value: item.name, text: item.name });
        }
      });
    },
    caseManagers(newVal) {
      this.formattedCaseManagers = [];

      newVal.forEach((item, index) => {
          this.formattedCaseManagers.push({ value: item.id, text: `${item.firstName} ${item.name}` });
      });
    },
    slices(newVal) {
      // Basis for all the stats
      this.slicesStats = newVal.slicesInTimeframe;

      // Slices in time frame
      this.slicesInTimeframe = this.slicesStats.length;

      // Open slices
      this.openSlices = newVal.ongoingSlices;

      // STATISTICS: Slices received in time (receptionDate < 15 days) - Filtered by Case Manager
      let slicesBasis = null;
      if (this.filterCaseManagers != null) {
        const caseManager = this.filterCaseManagers;
        slicesBasis = _.filter(this.slicesStats, function(o) {
          return (o.caseManager.id === caseManager);
        });
      } else {
        slicesBasis = this.slicesStats;
      }

      this.slicesReceivedInTime = _.filter(slicesBasis, function(o) {
          if (o.receptionDate != null) {
            return (Math.abs(moment(o.receptionDate, 'YYYY-MM-DD HH:mm:ss').diff(moment(o.ameoDate, 'YYYY-MM-DD HH:mm:ss'), 'days')) <= 15);
          }
      }).length;
      this.slicesNotReceivedInTime = slicesBasis.length - this.slicesReceivedInTime;

      if (this.slicesStats.length > 0) {
        this.$nextTick(() => {
          this.apexCharts.slicesUnderDelay.series = [this.slicesReceivedInTime, this.slicesNotReceivedInTime];
        });
      }

      // STATISTICS: Slices in conformity, over time
      let monthsProgression = this.getMonthsProgression();
      this.apexCharts.conformityProgression.options = {
        ...this.apexCharts.conformityProgression.options,
        ...{
          xaxis: {
            categories: monthsProgression,
          }
        }
      }

      this.$nextTick(() => {
        if ((newVal.conformityProgressionPercent && newVal.conformityProgressionPercent.length > 0)
            || (newVal.nonConformityProgressionPercent && newVal.nonConformityProgressionPercent.length > 0)) {
          this.displayConformityProgression = true;
          this.conformityProgressionPercent = [
            {
              name: 'Nombre de dossiers conformes',
              data: newVal.conformityProgressionPercent,
            },
            {
              name: 'Nombre de dossiers non conformes',
              data: newVal.nonConformityProgressionPercent,
            }
          ];
        } else {
          this.displayConformityProgression = false;
        }

        // Case conformity pie chart for manager
        this.conformCasesForManager = 0;
        this.nonConformCasesForManager = 0;

        newVal.conformityProgression.forEach(conformCase => {
          this.conformCasesForManager = this.conformCasesForManager + conformCase;
        });

        newVal.nonConformityProgression.forEach(nonConformCase => {
          this.nonConformCasesForManager = this.nonConformCasesForManager + nonConformCase;
        });

        if (this.conformCasesForManager > 0 || this.nonConformCasesForManager > 0) {
          this.displayConformityCasesForManager = true;
          this.apexCharts.conformityCasesForManager.series = [this.conformCasesForManager, this.nonConformCasesForManager];
        } else {
          this.displayConformityCasesForManager = false;
        }
      });

      // STATISTICS: Slices in delay, over time
      this.apexCharts.inDelayProgression.options = {
        ...this.apexCharts.inDelayProgression.options,
        ...{
          xaxis: {
            categories: monthsProgression,
          }
        }
      }

      this.$nextTick(() => {
        if ((newVal.inDelayProgressionPercent && newVal.inDelayProgressionPercent.length > 0)
            || (newVal.outDelayProgressionPercent && newVal.outDelayProgressionPercent.length > 0)) {
          this.displayDelayProgression = true;
          this.delayProgressionPercent = [
            {
              name: 'Dossiers reçus dans les délais',
              data: newVal.inDelayProgressionPercent,
            },
            {
              name: 'Dossiers reçus hors délais',
              data: newVal.outDelayProgressionPercent,
            }
          ];
        } else {
          this.displayDelayProgression = false;
        }

        // Case delay pie chart for manager
        this.inDelayForManager = 0;
        this.outDelayForManager = 0;

        newVal.inDelayProgression.forEach(delay => {
          this.inDelayForManager = this.inDelayForManager + delay;
        });

        newVal.outDelayProgression.forEach(delay => {
          this.outDelayForManager = this.outDelayForManager + delay;
        });

        if (this.inDelayForManager > 0 || this.outDelayForManager > 0) {
          this.displaySlicesUnderDelayForManager = true;
          this.apexCharts.slicesUnderDelayForManager.series = [this.inDelayForManager, this.outDelayForManager];
        } else {
          this.displaySlicesUnderDelayForManager = false;
        }
      });


      // STATISTICS: Slices with no gaps (Warning: gap with code "A01" should not be counted) - Filtered by Case Manager
      this.slicesWithNoGaps = null;
      this.slicesWithNoGaps = _.filter(slicesBasis, function(o) {
        if (o.gapHistories.length == 0) {
          return true;
        } else {
          let gapNum = 0;
          o.gapHistories.forEach(gapHistory => {
            if (gapHistory.archived == false) {
              gapHistory.gaps.forEach(gap => {
                if (gap.code != 'A01') {
                  gapNum++;
                }
              });
            }
          });

          return gapNum == 0;
        }
      }).length;
      this.slicesWithGaps = slicesBasis.length - this.slicesWithNoGaps;

      if (this.slicesStats.length > 0) {
        this.$nextTick(() => {
          this.apexCharts.slicesWithNoGaps.series = [this.slicesWithNoGaps, this.slicesWithGaps];
        });
      }

      // STATISTICS: Number of gaps in all returned slices, not counting doubles (eg. A1, B2, A1 = 2)
      this.nbGaps = 0;
      this.allGaps = [];
      this.gapTypes = [];
      this.gapTypesA = [];
      this.slicesStats.forEach((slice, index) => {
        if (slice.gapHistories.length > 0) {
          let gaps = [];
          slice.gapHistories.forEach((gapHistory, index) => {
            if (gapHistory.archived == false) {
              gapHistory.gaps.forEach((gap, index) => {
                // Filtering duplicates
                if (gaps.indexOf(gap.code) == -1) {
                  gaps.push(gap.code)
                  this.allGaps.push(gap.code);

                  // Populating the gapTypes var that's used in another statistics
                  if (gap.code.substring(0, 1) == 'A') {
                    this.gapTypesA.push({
                      code: gap.code,
                      type: gap.type,
                    });
                  }
                }

                // Populating gaps table data. Data should be distinct for the whole set
                let foundGap = false;
                this.tenMostCommonGaps.forEach((gapTable) => {
                  if (gapTable.code && gapTable.code == gap.code) {
                    foundGap = true;
                  }
                })
                if (foundGap === false) {
                  this.tenMostCommonGaps.push({
                    code: gap.code,
                    description: gap.description
                  });
                }
              });
            }
          });
          this.nbGaps = this.nbGaps + _.uniq(gaps).length;
        }
      });

      // STATISTICS: 10 most used gaps
      let codes = [];
      let key = null;

      // We shall test for all codes from 'A00' to 'B99'
      for (let index = 0; index <= 99; index++) {
        let countA = 0;
        let countB = 0;

        // Add leading 0 (code is a string)
        if (index < 9) {
          key = '0' + index.toString();
        } else {
          key = index.toString();
        }

        // Counting occurences
        for (let i = 0; i < this.allGaps.length; i++) {
          if (this.allGaps[i] == 'A' + key) {
            countA++;
          }

          if (this.allGaps[i] == 'B' + key) {
            countB++;
          }
        }

        // Hydrating array (ommiting empty results)
        if (countA > 0 || countB > 0) {
          codes.push({
            code: key,
            a: countA,
            b: countB,
            total: countA + countB,
          });
        }
      }

      // Sorting array by total (desc)
      codes.sort((a, b) => (b.total > a.total) ? 1 : -1);

      // Truncate result array to get only the first ten results
      codes.splice(10);

      // Resetting stackedBar object
      this.stackedBar.datasets = [{
          label: 'A',
          data: [],
        },
        {
          label: 'B',
          data: [],
        }];

      // Organizing data
      codes.forEach((code, index) => {
        this.apexCharts.tenMostCommonGaps.options.xaxis.categories.push(code.code);
        this.stackedBar.datasets.forEach((dataset, index) => {
          if (dataset.label == 'A') {
            dataset.data.push(code.a);
          }

          if (dataset.label == 'B') {
            dataset.data.push(code.b);
          }
        });
      });

      // Adding graph
      if (codes.length > 0) {
        this.stackedBar.datasets.forEach((dataset, index) => {
          let name = '';
          if (dataset.label === 'A') {
            name = 'Non reçus (A)';
          } else if (dataset.label === 'B') {
            name = 'Reprise par Agence Cartographie (B)';
          }

          this.$nextTick(() => {
            this.apexCharts.tenMostCommonGaps.series.push({
              name: name,
              data: dataset.data,
            });
          });
        });
      }

      // STATISTICS: Gap type
      this.gapTypeIncomplete = 0;
      this.gapTypeInadmissible = 0;
      this.gapTypeReactive = 0;

      this.gapTypesA.forEach((gap, index) => {
        if (gap.type == 1) { this.gapTypeReactive++; }
        if (gap.type == 2) { this.gapTypeIncomplete++; }
        if (gap.type == 3) { this.gapTypeInadmissible++; }
      });

      // Draw graph
      if (this.slicesStats.length > 0) {
        this.$nextTick(() => {
          this.apexCharts.gapTypes = {
            series: [this.gapTypeIncomplete, this.gapTypeInadmissible, this.gapTypeReactive],
            options: {
              labels: [
                'Incomplétude',
                'Irrecevabilité',
                'Réactivité',
              ],
              dataLabels: {
                formatter: function(val, opts) {
                  return `${opts.w.globals.labels[opts.seriesIndex]} : ${opts.w.globals.series[opts.seriesIndex]} (${opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(2)}%)`;
                },
              },
            }
          }
        });
      }
    }
  },
  beforeMount() {
    // Initializing ApexCharts data
    this.resetApexChartsData();
  },
  mounted() {
    // Checking if agencies are in the Store. If not, fetch and store them
    if (this.getAgencies().length == 0) {
      this.$store.dispatch('fetchAgencies').then(() => { this.agencies = this.getAgencies(); });
    } else {
      this.agencies = this.getAgencies();
    }

    // Checking if case managers are in the Store.
    if (this.getCaseManagers().length == 0) {
      this.$store.dispatch('fetchCaseManagers').then(() => { this.caseManagers = this.getCaseManagers(); });
    } else {
      this.caseManagers = this.getCaseManagers();
    }

    let currentYear = moment(new Date(), 'YYYY-MM-DD HH:mm').format('YYYY');

    this.slice.from = moment(currentYear + '-01-01 00:01', 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
    this.slice.to = moment(currentYear + '-12-31 23:59', 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#picto-filter {
  width: 27px;
}

.chart {
  max-width: 300px;
  max-height: 300px;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}

.tooltip-message {
  border-bottom: 1px dotted;
}

.filter {
  background-color: #fff;
  padding: 15px 30px;
  border-radius: 3px;
  margin-top: 35px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .group {
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
  }

  label {
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 0;
  }

  @media screen and (max-width: 1600px) {
    label {
      margin: 0 0 10px 0;
    }
    .group {
      flex-direction: column;
    }
  }

  @media screen and (max-width: 1270px) {
    flex-direction: column;

    #picto-filter {
      display: none;
    }

    label,
    .mr-sm-2 {
      margin: 0 0 5px 0 !important;
    }

    .group {
      margin-bottom: 20px;

      &:first-child {
        margin: 0;
      }
    }

    #filterResetBtn {
      margin: 0;
    }
  }
}
#filterResetBtn {
  background-color: white;
  border-color: #005EB8;
  padding: 8px 25px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  #picto-reset {
    width: 18px;
    height: 18px;
    margin-right: 5px;
    -webkit-mask: url('/static/img/reset.svg') no-repeat center;
    mask: url('/static/img/reset.svg') no-repeat center;
    background-color: #005EB8;
    display: inline-block;
  }

  &:hover {
    background-color: #005EB8;
    color: white;

    #picto-reset {
      background-color: white;
    }
  }
}

.tranche-date-picker {
  width: 140px;
}

#sendFilter {
  padding: 8px 25px;
}

.stats-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items:flex-start;
  margin-top: 30px;
  margin-bottom: 30px;

  .stat {
    text-align: center;
  }
}

.centered-block {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 30px;
}

.stat-toggle-btn {
  background-color: #EFF3F8;
  border-radius: 0;
  font-size: 17px;
  color: #143F73;
  border: 0;

  &:hover {
    background-color: #DBDFE5;
  }
}

.stats-main-container {
  margin-top: 50px;
}

.centered-chart {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/statistics/Statistics.vue